import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { IRecruitSFilter } from 'src/@types/SearchFilterTypes';
import { RHFSelect, RHFTextField } from 'src/components/hook-form';
import FormProvider from 'src/components/hook-form/FormProvider';
import { FormItem, SearchFormLayout } from 'src/layouts/form/FormLayout';
import { useStores } from 'src/models';
import removeNullUndefined from 'src/utils/removeNullUndefined';

export interface ISearchFormProps {
  onSearch: (data: IRecruitSFilter) => void;
}

export const SearchForm = observer(({ onSearch }: ISearchFormProps) => {
  const { commonCodeStore } = useStores();
  const { t } = useTranslation();
  // 경력여부
  const EXP_CD = commonCodeStore.getCCodeByName('EXP_CD');
  // 지원분야
  const { applySelectOptions } = commonCodeStore;
  // 처리상태
  const RECRUIT_STATUS_CD = commonCodeStore.getCCodeByName('RECRUIT_STATUS_CD');
  const methods = useForm<IRecruitSFilter>({
    defaultValues: {
      expCd: '',
      applyFieldCd: '',
      recruitStatusCd: '',
      viewYn: '',
      nameKr: '',
      phone: '',
    },
  });

  // 검색 함수
  const onValid = (data: IRecruitSFilter) => {
    const cleanedData = removeNullUndefined(data);
    onSearch(cleanedData);
  };

  return (
    <FormProvider methods={methods} onSubmit={methods.handleSubmit(onValid)}>
      <SearchFormLayout method={methods} open={true} cols={4}>
        <FormItem>
          <RHFSelect
            label={`${t('recruitment.fields.expCd.name')}`}
            name="expCd"
            options={EXP_CD || []}
          />
        </FormItem>
        <FormItem>
          <RHFSelect
            label={t('recruitment.fields.applyFieldCd.name')}
            name="applyFieldCd"
            options={applySelectOptions}
          />
        </FormItem>
        <FormItem>
          <RHFSelect
            label={t('recruitment.fields.status.name')}
            name="recruitStatusCd"
            options={RECRUIT_STATUS_CD || []}
          />
        </FormItem>
        <FormItem>
          <RHFSelect
            label={t('recruitment.fields.viewYn.name')}
            name="viewYn"
            options={[
              { label: t('recruitment.fields.viewYn.true'), value: true },
              { label: t('recruitment.fields.viewYn.false'), value: false },
            ]}
          />
        </FormItem>
        <FormItem>
          <RHFTextField label={t('recruitment.fields.nameKr.name')} name="nameKr" />
        </FormItem>
        <FormItem>
          <RHFTextField label={t('recruitment.fields.nameEn.name')} name="nameEn" />
        </FormItem>
        <FormItem size={2}>
          <RHFTextField label={t('recruitment.fields.phone.name')} name="phone" />
        </FormItem>
      </SearchFormLayout>
    </FormProvider>
  );
});

export default SearchForm;
